import React from 'react';
import { Button, Icon } from '@amzn/awsui-components-react';

/*const getEndpoint = (sandbox) => {
    verify(() => {
    const opts = getOptions();
    opts.method = 'GET';
    // const user = "user=" + localStorage.getItem('userId');
    const account = `account=954370645355`;
    fetch(`${getApiUrl()}/get_sandbox_endpoint_url?user=miaoqi&${account}&sandbox_id=${sandbox}`, opts)
        .then(res => res.json())
        .then(data => {
            ;
        })
        .catch(console.log)
    });
}*/

export const COLUMN_DEFINITIONS = [
  {
    id: 'name',
    header: () => 'Sandbox Name',
    cell: item => (
      <div>
        <a href={`/update/${item.sandboxId}`}>{item.sandboxId}</a>
      </div>
    ),
    minWidth: '180px',
    allowLineWrap: true
  },
  {
    id: 'status',
    cell: item => ( 
      <div className={`awsui-util-status-${item.status === 'Stopped' ? 'inactive' : (item.status === 'InService') ? 'positive' : 'info'}`}>
          <Icon name={item.status === 'Stopped' ? 'status-negative' : (item.status === "InService") ? 'status-positive' : "status-in-progress"} />
          <span>{` ${item.status}`}</span>
        </div>
      ),
    header: () => 'Status',
    minWidth: '160px',
    allowLineWrap: true
  },
  {
    id: 'type',
    header: () => 'Instance Type',
    cell: item => item.type,
    minWidth: '100px',
    allowLineWrap: true
  },
  {
    id: 'size',
    header: () => 'Size',
    cell: item => item.size,
    minWidth: '100px',
    allowLineWrap: true
  },
  {
    id: 'idleTime',
    header: () => 'Idle Time',
    cell: item => item.idleTime,
    minWidth: '100px',
    allowLineWrap: true
  },
  {
    id: 'idleThreshold',
    header: () => 'Idle Threshold',
    cell: item => item.idleThreshold,
    minWidth: '100px',
    allowLineWrap: true
  },
  {
    id: 'actions',
    header: () => 'Actions',
    cell: item => (<div style={{textAlign: "center"}}>{(item.status === "InService") ?
        <Button onClick={() => item.endpoint(item.sandboxId)}>Connect</Button>
        : "-"}</div>),
    minWidth: '180px',
    allowLineWrap: true
  }
];

export const SORTABLE_COLUMNS = [
  { id: 'name', field: 'sandboxId' },
  { id: 'status', field: 'status' },
  { id: 'type', field: 'type' },
  { id: 'size', field: 'size' },
  { id: 'idleTime', field: 'idleTime' },
  { id: 'idleThreshold', field: 'idleThreshold' }
];

export const CONTENT_SELECTOR_OPTIONS = [
  {
    label: 'Main sandbox properties',
    options: [
      { id: 'name', label: 'Sandbox name', editable: false, visible: true },
      { id: 'status', label: 'Status', editable: true, visible: true },
      { id: 'type', label: 'Instance type', editable: true, visible: true },
      { id: 'size', label: 'Size', editable: true, visible: false },
      { id: 'idleTime', label: 'Idle time', editable: true, visible: true },
      { id: 'idleThreshold', label: 'Idle threshold', editable: true, visible: false },
      { id: 'actions', label: 'Actions', editable: false, visible: true }
    ]
  }
];

export const PAGE_SELECTOR_OPTIONS = [
  { value: 10, label: '10 Sandboxes' },
  { value: 30, label: '30 Sandboxes' },
  { value: 50, label: '50 Sandboxes' }
];

export const PROPERTY_FILTERING_OPTIONS = [
  { propertyLabel: 'Sandbox name', propertyKey: 'sandboxId', groupValuesLabel: 'Sandbox name values', values: [] },
  { propertyLabel: 'Status', propertyKey: 'status', groupValuesLabel: 'Status values', values: [] },
  { propertyLabel: 'Instance type', propertyKey: 'type', groupValuesLabel: 'Instance type values', values: [] },
  { propertyLabel: 'Size', propertyKey: 'size', groupValuesLabel: 'Size values', values: [] },
  { propertyLabel: 'Idle time', propertyKey: 'idleTime', groupValuesLabel: 'Idle time values', values: [] },
  { propertyLabel: 'Idle threshold', propertyKey: 'idleThreshold', groupValuesLabel: 'Idle threshold values', values: [] }
];

export const CUSTOM_PREFERENCE_OPTIONS = [
  { value: 'table', label: 'Table' },
  { value: 'cards', label: 'Cards' }
];

export const PROPERTY_FILTERING_I18N_CONSTANTS = {
  placeholder: 'Filter sandboxes by property or value',
  operationAndText: 'and',
  operationNotAndText: 'and not',
  operationOrText: 'or',
  operationNotOrText: 'or not',
  clearFiltersText: 'Clear filters',
  groupPropertiesText: 'Properties',
  groupValuesText: 'Values',
  filteringEmpty: 'No results found',
  filteringLabel: 'Filter sandboxes',
  filteringStatusText: 'Loading'
};
